import { render, staticRenderFns } from "./ColorMixerView.vue?vue&type=template&id=55110b30&scoped=true&lang=pug&"
import script from "./ColorMixerView.vue?vue&type=script&lang=js&"
export * from "./ColorMixerView.vue?vue&type=script&lang=js&"
import style0 from "./ColorMixerView.vue?vue&type=style&index=0&id=55110b30&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55110b30",
  null
  
)

export default component.exports